import axios from "axios";
import React, {Component} from "react";
import { Link } from "react-router-dom";
import Select from 'react-select';
import Modal from "react-bootstrap/Modal";
import FeatherIcon from 'feather-icons-react';
import ParentfamilyForm from "../parentfamilies/ParentfamilyForm";
import ProfilImage from "../../users/ProfileImage";
import TerritoryForm from "../territories/TerritoryForm";
import CommuneForm from "../communes/CommuneForm";
import GroupmentForm from "../groupments/GroupmentForm";
import QuartierForm from "../quartiers/QuartierForm";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";

const STUDENT_FIELD_RULES = {
    profileId: { step: 0, label: "Le profil Élève"  },
    responsible: { step: 0, label: "Le responsable", required: true },
    class: { step: 0, label: "La classe", required: true },
    last_name: { step: 1, label: "Le nom", required: true, minLength: 2, maxLength: 50 },
    first_name: { step: 1, label: "Le prénom", maxLength: 50 },
    family_name: { step: 1, label: "Le post-nom", maxLength: 50 },
    // matricule: { step: 1, label: "Le matricule", required: true, maxLength: 20 },
    identity_number: { step: 1, label: "Le numéro d'identité", maxLength: 50 },
    email: { step: 1, label: "L'adresse e-mail", maxLength: 80 },
    tel: { step: 1, label: "Le téléphone", exactLength: 9, maxLength: 9 },
    adress: { step: 1, label: "Le lieu de naissance", maxLength: 100 },
    numberId: { step: 1, label: "Le numéro ID", maxLength: 20 },
    number_perm: { step: 1, label: "Le numéro permanent", maxLength: 50 },
    code: { step: 1, label: "Le code", maxLength: 20 },
    genre: { step: 2, label: "Le genre", maxLength: 10 },
};

class   StudentForm extends Component{

    state = {
        id : "",
        avatar : false,
        responsible: "",
        sectionId : null,
        motherId : null,
        fatherId : null,
        territoryId : null,
        communeId : null,
        groupmentId : null,
        quartierId : null,
        isTerritory : false,
        isCommune : false,
        isGroupment : false,
        isQuartier : false,
        excel : null,
        entryMode : "manual",
        currentStep : 0,
        class : "",
        classesCompare : [],
        matricule : "",
        userId : "",
        first_name : "",
        last_name : "",
        family_name : "",
        genre : "Masculin",
        staff_student : "Non",
        status : 1,
        email : null,
        tel : null,
        identity_number : "",
        password : "",
        datebirth : null,
        title : "",
        adress : "",
        profiles : [],
        profileId : "",
        errors : {},
        error : "",
        yearId : null,
        number_perm : "",
        numberId : "",
        category_student : "",
        number_house : "",
        code : "",
        name_category : "",
        sectschoolcatstudcat : "",

        isModal : false,
        btn : false,
        sections : [],
        section :"",
        responsibles : [],
        territories : [],
        communes : [],
        groupments : [],
        quartiers : [],
        years : [],
        categorystudents : [],
        sectschoolcatstudcats : [],
    }

    handleInput = (e) => {
        const { name, value } = e.target;
        this.setState((state) => ({
            [name]: value,
            error: "",
            errors: { ...state.errors, [name]: "" },
        }));
    }

    handleInputAvatar = (e) => {
        this.setState({
            avatar : !this.state.avatar
        }); 
    }

    storeStudent = ( val = null) =>{
        const { errors, firstStep } = this.validate();
        if (Object.keys(errors).length) {
            this.setState({ errors, error: Object.values(errors)[0], currentStep: firstStep });
            return;
        }

        const clean = (value) => String(value ?? "").trim();
        var data = {
                user : {
                    userId: this.state.responsible,
                    first_name : clean(this.state.first_name) || null,
                    last_name : clean(this.state.last_name),
                    family_name : clean(this.state.family_name) || null,
                    genre : clean(this.state.genre) || 'Masculin',
                    email : clean(this.state.email) || null,
                    tel : clean(this.state.tel) || null,
                    scolary_year : this.state.yearId,
                    identity_number : clean(this.state.identity_number) || null,
                    datebirth : this.state.datebirth ? this.state.datebirth : null,
                    adress : clean(this.state.adress) || null,
                },
                student : {
                    yearId : this.state.yearId,
                    territoryId : this.state.territoryId,
                    communeId : this.state.communeId,
                    groupmentId : this.state.groupmentId,
                    quartierId : this.state.quartierId,
                    number_house : this.state.number_house === "" || this.state.number_house === null ? null : Number(this.state.number_house),
                    sectionclasseId : this.state.class,
                    motherId : this.state.motherId ? this.state.motherId : null,
                    fatherId : this.state.fatherId ? this.state.fatherId : null,
                    matricule : clean(this.state.matricule) || null,
                    number_perm : clean(this.state.number_perm) || null,
                    numberId : clean(this.state.numberId) || null,
                    code : clean(this.state.code) || null,
                    operation : this.state.id ? (val === 1 ? "Archiver" : "Editer" ) : "Ajouter",
                    staff_student : this.state.staff_student,
                    status : Number(this.state.status),
                },
                profileId : this.state.profileId ? this.state.profileId : null,
                category_student : this.state.category_student,
                sectschoolcatstudcat : this.state.sectschoolcatstudcat,
            }
            this.setState({ btn : true, errors: {}, error: ""})
        
        var request = this.state.id ? axios.put('students/'+this.state.id, data) : axios.post('students', data);
        request.then((response) =>{
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}})
            this.setState({ btn : false})
            this.props.showModal(null, false, 1)
        }).catch((error) => {
            this.setState({
                error : error.response?.data?.msg || "Une erreur est survenue."
            })
            this.setState({ btn : false})
            toast(error.response?.data?.msg || "Une erreur est survenue.", { theme : "light", style : { backgroundColor : "red", color : "white"}})
        })
    }

    async responsibles(){
        var request = await axios.get('parentfamilies');
        if(request.status === 200)
            this.setState({responsibles : request.data})
    }

    async categorystudents(){
        var request = await axios.get('categorystudents');
        if(request.status === 200)
            this.setState({categorystudents : request.data})
    }

    async sections(){
        var request = await axios.get('sections');
        if(request.status === 200)
            this.setState({sections : request.data})
    }

    async territories(){
        var request = await axios.get('territories');
        if(request.status === 200)
            this.setState({territories : request.data})
    }

    async quartiers(){
        var request = await axios.get('quartiers');
        if(request.status === 200)
            this.setState({quartiers : request.data})
    }

    async communes(){
        var request = await axios.get('communes');
        if(request.status === 200)
            this.setState({communes : request.data})
    }

    async groupments(){
        var request = await axios.get('groupments');
        if(request.status === 200)
            this.setState({groupments : request.data})
    }
    
    async getYear(){
        var data=[], years = await axios.get('years');
        if(years.status === 200)
        {
            let yearId = null
            years.data.map((year) => {
                data.push({value : year.id, label : year.year})
                yearId = year?.id
            })
            
            this.setState({
                years : data,
                yearId : yearId
            })
        }
    }

    async profiles(){
        var request = await axios.get('profiles');
        if(request.status === 200){
            this.setState({profiles : request.data})
            request.data.map((profile) => {
                if(profile.model == "Student")
                    this.setState({ profileId : profile.id})
            });
        }
    }

    edit = () =>  {
        this.form()
        this.getYear()
        this.categorystudents()
        this.responsibles()
        this.profiles();
        this.sections()
        this.territories()
        this.groupments()
        this.communes()
        this.quartiers()
    }

    form=()=>{
        
        this.setState({
            id : this.props.formData ? this.props.formData.id : "",
            sectionId : this.props.formData ? this.props.formData.sectionclass ? this.props.formData.sectionclass?.sectionId : null : null,
            // class : this.props.formData ? this.props.formData.sectionclass ? this.props.formData.sectionclass?.id : null : null,
            motherId : this.props.formData ? this.props.formData.motherId : null,
            fatherId : this.props.formData ? this.props.formData.fatherId ? this.props.formData.fatherId  : this.props.formData ? this.props.formData.user ?  this.props.formData.user.user.id : null : null : null,
            territoryId : this.props.formData ? this.props.formData.territoryId : null,
            groupmentId : this.props.formData ? this.props.formData.groupmentId : null,
            communeId : this.props.formData ? this.props.formData.communeId : null,
            quartierId : this.props.formData ? this.props.formData.quartierId : null,
            number_house : this.props.formData ? this.props.formData.number_house : null,
            category_student: this.props.formData ? this.props.formData.categorystudent ?  this.props.formData.categorystudent.id : "" : "",
            responsible: this.props.formData ? this.props.formData.user ?  this.props.formData.user?.user?.id : "" : "",
            class : this.props.formData ? this.props.formData.sectionclass ? this.props.formData.sectionclass?.id : this.props.classe : this.props.classe,
            matricule : this.props.formData ?  this.props.formData.matricule ? this.props.formData.matricule : this.props.matricule : "",
            userId : this.props.formData ? this.props.formData.user ?  this.props.formData.user.id : "" : "",
            first_name : this.props.formData ? this.props.formData.user ?  this.props.formData.user.first_name : "" : "",
            last_name : this.props.formData ? this.props.formData.user ?  this.props.formData.user.last_name : "" : "",
            family_name : this.props.formData ? this.props.formData.user ?  this.props.formData.user.family_name : "" : "",
            genre : this.props.formData ? this.props.formData.user ?  this.props.formData.user.genre : "Masculin" : "Masculin",
            number_perm : this.props.formData ? this.props.formData.number_perm : null,
            staff_student : this.props.formData ? this.props.formData.staff_student : "Non",
            status : this.props.formData ? this.props.formData.status ? this.props.formData.status : 1 : 1,
            numberId : this.props.formData ? this.props.formData.numberId : null,
            code : this.props.formData ? this.props.formData.code : null,
            yearId : this.props.formData ? this.props.formData.year ? this.props.formData.year.id : this.state.yearId: this.state.yearId,
            email : this.props.formData ? this.props.formData.user ?  this.props.formData.user.email : null : null,
            tel : this.props.formData ? this.props.formData.user ?  this.props.formData.user.tel : null : null,
            identity_number : this.props.formData ? this.props.formData.user ?  this.props.formData.user.identity_number : "" : "",
            datebirth : this.props.formData ? this.props.formData.user ?  this.props.formData.user.datebirth : null : null,
            adress : this.props.formData ? this.props.formData.user ?  this.props.formData.user.adress : "" : "",
            title : this.props.formData && this.props.formData.id ? ( this.props.isArchived ? "Désarchiver l'élève" : "Modifier l'élève" ) : "Ajouter un élève",
            avatar : false,
            entryMode : "manual",
            currentStep : 0,
            errors : {},
            error : "",
        });
    }

    showModal = (data = null) => {
        const responsibleId = data?.user?.id || data?.userId;
        this.setState({
            isModal : !this.state.isModal,
            responsible : responsibleId || this.state.responsible,
            fatherId : responsibleId || this.state.responsible,
        })
        this.responsibles()
    }

    showModalTerritory = (data = null) => {
        this.setState({
            isTerritory : false,
            territoryId : data ? data.id : this.state.territoryId
        })
        this.territories()
    }

    showModalCommune = (data = null) => {
        this.setState({
            isCommune : false,
            communeId : data ? data.id : this.state.communeId
        })
        this.communes()
    }

    showModalGroupment= (data = null) => {
        this.setState({
            isGroupment: false,
            groupmentId : data ? data.id : this.state.groupmentId
        })
        this.groupments()
    }

    showModalQuartier = (data = null) => {
        this.setState({
            isQuartier : false,
            quartierId : data ? data.id : this.state.quartierId
        })
        this.quartiers()
    }

    async sectschoolcatstudcats () {
        var classe = this.props.formData ? this.props.formData.class ? this.props.formData.class.id : this.props.classe : this.props.classe;
        var sectschoolcatstudcats = await axios.get('sectschoolcatstudcats/estblsectclass/'+classe);
        
        if(sectschoolcatstudcats.status == 200)
        {
            this.setState({
                sectschoolcatstudcats : sectschoolcatstudcats.data
            })
        }
    }

    handleExportExemple = () => {
        let jsonData = []
        jsonData.push({
            studentLastName : '',
            studentFamilyName : '',
            studentFirstName : '',
            studentGender : '',
            parentLastName : '',
            parentFamilyName : '',
            parentGender : '',
            parentTelephon : '',
        })
        const worksheet = XLSX.utils.json_to_sheet(jsonData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, 'Formulaire_eleve_'+ new Date()?.toLocaleDateString() +".xlsx");
    };

    handleUpload=(val)=>{
        this.setState({ excel : val})
    }

    setEntryMode = (entryMode) => {
        this.setState({ entryMode, currentStep: 0, errors: {}, error: "" });
    }

    goToStep = (currentStep) => {
        if (currentStep > this.state.currentStep) {
            let errors = {};
            for (let step = this.state.currentStep; step < currentStep; step += 1) errors = { ...errors, ...this.validateStep(step) };
            if (Object.keys(errors).length) {
                this.setState({ errors, error: Object.values(errors)[0] });
                return;
            }
        }
        this.setState({ currentStep, errors: {}, error: "" });
    }

    validateStep = (step) => {
        const errors = {};
        Object.entries(STUDENT_FIELD_RULES).forEach(([name, rule]) => {
            if (rule.step !== step) return;
            const value = String(this.state[name] ?? "").trim();
            if (rule.required && !value) errors[name] = rule.label + " est obligatoire.";
            else if (value && rule.exactLength && value.length !== rule.exactLength) errors[name] = rule.label + " doit contenir exactement " + rule.exactLength + " caractères.";
            else if (value && rule.minLength && value.length < rule.minLength) errors[name] = rule.label + " doit contenir au moins " + rule.minLength + " caractères.";
            else if (value && rule.maxLength && value.length > rule.maxLength) errors[name] = rule.label + " ne peut pas dépasser " + rule.maxLength + " caractères.";
        });
        if (step === 1 && this.state.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(this.state.email).trim())) errors.email = "L'adresse e-mail n'est pas valide.";
        if (step === 2 && this.state.number_house !== "" && this.state.number_house !== null) {
            const value = Number(this.state.number_house);
            if (!Number.isInteger(value) || value < 0) errors.number_house = "Le numéro d'habitation doit être un entier positif ou nul.";
        }
        return errors;
    }

    validate = () => {
        const stepErrors = [0, 1, 2].map((step) => this.validateStep(step));
        const errors = Object.assign({}, ...stepErrors);
        const firstStep = stepErrors.findIndex((item) => Object.keys(item).length);
        return { errors, firstStep: firstStep < 0 ? 0 : firstStep };
    }

    handleExportSave = async() =>{
        const formData = new FormData();
        this.setState({ btn : !this.state.btn })
        formData.append("status", 1);
        formData.append("file", this.state.excel);
        if(this.state.class)
            formData.append("sectionclasseId", this.state.class);
        if(this.state.yearId)
            formData.append("yearId", this.state.yearId);
        if(this.state.profileId)
            formData.append("profileId", this.state.profileId);

        if (this.state.classesCompare?.length > 0) {
            this.state.classesCompare.forEach((classId) => {
                formData.append("classesCompare[]", classId);
            });
        }
        let user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : {};
        
        const response = await fetch(process.env.REACT_APP_APIEVIVESOMA + '/studentsexcel', {
            method: "POST",
            headers: {
                'Accept':'*/*',
                'Authorization':'Bearer ' + (user.refresh_token ? user.refresh_token : ""),
            },
            body: formData 
        })
        
        if (response.status === 200){
            this.setState({
                excel : null,
                btn : !this.state.btn
            })
            toast('Liste des eleves bien enregistree', { theme : "light", style : { backgroundColor : "blue", color : "white"}})
        }
        else{
            this.setState({
                btn : !this.state.btn
            })
            let data = await response.json()
            toast(data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}})
        }
    }

  handleCheck(val) {
    let permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        const selectMenuProps = {
            menuPortalTarget: typeof document !== "undefined" ? document.body : null,
            menuPosition: "fixed",
            classNamePrefix: "student-select",
            styles: { menuPortal: (base) => ({ ...base, zIndex: 1060 }) },
        };
        
        let optionsections = [], optionCompareSectionClasses = [], optionsectionclasses = [], optionresponsibles= [], optioncategorystudents = [], optionsectschoolcatstudcats = [], optionterritories = [], optionscommunes = [], optiongroupments = [], optionquarties = [];
        

        this.state.sections.map((section) => {
            optionsections.push({value : section, label :  section.entitled_section + " (" + section.short_entitled_section + ")"})
         
            section.sectionclasses?.forEach(sectionclasse => {
                optionCompareSectionClasses.push({
                    value: sectionclasse.id,
                    label:
                        sectionclasse.class.short_entitled_class +
                        " " +
                        sectionclasse.title + ' ' + section.short_entitled_section
                });
            });
        });

        optionterritories.push({ value : null, label : "Nouvelle region /  territoire"})
        optiongroupments.push({ value : null, label : "Nouveau groupement"})
        optionquarties.push({ value : null, label : "Nouveau quartier"})
        optionscommunes.push({ value : null, label : "Nouveau commune"})
        
        this.state.territories.map((terrirory) => {
            optionterritories.push({value : terrirory.id, label :  terrirory.name })
        });

        this.state.groupments.filter(data => data.territoryId == this.state.territoryId).map((groupment) => {
            optiongroupments.push({value : groupment.id, label :  groupment.name })
        });

        this.state.communes.filter(data => data.territoryId == this.state.territoryId).map((commune) => {
            optionscommunes.push({value : commune.id, label :  commune.name })
        });

        this.state.quartiers.filter(data => data.groupmentId == this.state.groupmentId || data.communeId == this.state.communeId).map((quartier) => {
            optionquarties.push({value : quartier.id, label :  quartier.name })
        });

        this.state.responsibles.map((responsible) => {
            optionresponsibles.push({value : responsible.user.id, label : (responsible.user.last_name || '') + "  "+ (responsible.user.family_name || '') +"  "+ (responsible.user.first_name || '') +" "+(responsible.user.tel || ''), family_name : responsible.user.last_name})
        });

        this.state.categorystudents.map((categorystudent) => {
            optioncategorystudents.push({ value : categorystudent.id, label : categorystudent.category_student })
        });
        
        if(this.state.sectionId && optionsections.length > 0)
        {
            if(this.state.sections.filter(dat => dat.id == this.state.sectionId).length > 0 )
            {
                this.state.sections.filter(dat => dat.id == this.state.sectionId)[0].sectionclasses.map((sectionclasse) =>{
                    optionsectionclasses.push({value : sectionclasse.id, label : sectionclasse.class.short_entitled_class + "  "+ sectionclasse.title})
                })
            }
        }

        this.state.sectschoolcatstudcats.map((sectschoolcatstudcat) => {
            if(this.state.category_student == sectschoolcatstudcat.categorystudent.id)
            {
                optionsectschoolcatstudcats.push({
                    value : sectschoolcatstudcat.id,
                    label : sectschoolcatstudcat.price + "" + sectschoolcatstudcat.sectionschoolfeecategory.currency + " "+ sectschoolcatstudcat.categorystudent.category_student + " " + sectschoolcatstudcat.sectionschoolfeecategory.schoolfeecategory.category
                })
            }
        })
        return(
            <div>
            <Modal 
                show={this.props.isModal} 
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="student-form-dialog"
                contentClassName="student-form-modal student-form-modal--compact"
                onEntered={this.edit}
                backdrop={"static"}>
                <Modal.Header>
                    <div className="student-form__heading">
                        <span className="student-form__heading-icon"><FeatherIcon icon="user" size="20" /></span>
                        <div>
                            <span className="student-form__eyebrow">Dossier élève</span>
                            <Modal.Title>{this.state.title}</Modal.Title>
                            <Link className="student-form__manual-link" to="/manuel#student-form">
                                <FeatherIcon icon="book-open" size="13" /> Consulter les proc&eacute;dures et obligations
                            </Link>
                        </div>
                    </div>
                    {!this.state.id && <div className="student-entry-mode student-entry-mode--header" role="tablist" aria-label="Mode d'ajout">
                        <button type="button" role="tab" aria-selected={this.state.entryMode === "manual"} className={this.state.entryMode === "manual" ? "is-active" : ""} onClick={() => this.setEntryMode("manual")}>
                            <span><FeatherIcon icon="user-plus" size="16" /></span><strong>Saisie manuelle</strong>
                        </button>
                        <button type="button" role="tab" aria-selected={this.state.entryMode === "excel"} className={this.state.entryMode === "excel" ? "is-active" : ""} onClick={() => this.setEntryMode("excel")}>
                            <span><FeatherIcon icon="file-text" size="16" /></span><strong>Import Excel</strong>
                        </button>
                    </div>}
                </Modal.Header>
                    <Modal.Body className="row student-form__body">
                        {this.state.error && <div className="col-12"><div className="student-form__alert" role="alert"><FeatherIcon icon="alert-circle" size="17" /><span>{this.state.error}</span></div></div>}

                        {this.state.entryMode === "excel" && !this.state.id ? <>
                            <div className="col-12 student-import-panel">
                                <span className="student-import-panel__icon"><FeatherIcon icon="upload-cloud" size="25" /></span>
                                <div className="student-import-panel__copy"><strong>Importer une liste d'élèves</strong><p>Utilisez le modèle fourni, complétez-le puis sélectionnez le fichier Excel.</p></div>
                                <button className="student-form__tool-button" onClick={() => this.handleExportExemple()} type="button"><FeatherIcon icon="download" size="16" /> Télécharger le modèle</button>
                            </div>
                            {!this.props.classe && <>
                                <div className="form-group col-md-7 mt-3">
                                    <label>Section<span className="text-danger">*</span></label>
                                    <Select {...selectMenuProps} className="form-control form-control-sm p-0" value={optionsections.filter(option => option.value.id === this.state.sectionId)} onChange={(select) => this.setState({ sectionId: select.value.id, class: "" })} options={optionsections} />
                                </div>
                                <div className="form-group col-md-5 mt-3">
                                    <label>Classe affectée<span className="text-danger">*</span></label>
                                    <Select {...selectMenuProps} className="form-control form-control-sm p-0" value={optionsectionclasses.filter(option => option.value === this.state.class)} onChange={(select) => this.setState({ class: select.value })} options={optionsectionclasses} />
                                </div>
                            </>}
                            <div className="form-group col-md-5 mt-3">
                                <label>Année scolaire<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps} disabled={true} className="form-control form-control-sm p-0" value={this.state.years.filter(option => option.value === this.state.yearId)} onChange={(select) => this.setState({ yearId: select.value })} options={this.state.years} />
                            </div>
                            <div className="col-md-7 mt-3">
                                <label className="student-import-dropzone">
                                    <FeatherIcon icon="paperclip" size="19" /><span><strong>{this.state.excel ? this.state.excel.name : "Choisir le fichier Excel"}</strong><small>Formats .xlsx ou .xls</small></span>
                                    <input type="file" accept=".xlsx,.xls" onChange={(e) => this.handleUpload(e.target.files[0])} />
                                </label>
                            </div>
 
                            <div className="col-12 mt-2">
                                <div className="p-1 border rounded bg-light">
                                    

                                    <div className="row">
                                        <div className="form-group col-md-6 mt-2">
                                            <div className="mb-2">
                                                <strong>Paramètres facultatifs</strong>
                                                <small className="d-block text-muted">
                                                    Ces informations ne sont pas obligatoires pour importer les élèves.
                                                </small>
                                            </div>
                                        </div>

                                        <div className="form-group col-md-6 mt-1">
                                            <label>
                                                Classe à comparer <small className="text-muted">(facultatif)</small>
                                            </label>

                                            <Select
                                                {...selectMenuProps}
                                                className="form-control form-control-sm p-0"
                                                value={optionCompareSectionClasses.filter(option =>
                                                    this.state.classesCompare.includes(option.value)
                                                )}
                                                onChange={(select) => this.setState({
                                                    classesCompare: select
                                                        ? select.map(option => option.value)
                                                        : []
                                                })}
                                                options={optionCompareSectionClasses}
                                                isMulti
                                                closeMenuOnSelect={false}
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 student-import-actions">
                                <button className="btn btn-primary student-form__button" disabled={this.state.btn || !this.state.excel || !this.state.class || !this.state.yearId} onClick={() => this.handleExportSave()} type="button"><FeatherIcon icon="upload" size="16" /> {this.state.btn ? "Import en cours..." : "Importer les élèves"}</button>
                            </div>
                        </> : <>
                        <div className="col-12 student-form__progress" aria-label={`Etape ${this.state.currentStep + 1} sur 3`}>
                            <div className="student-form__progress-track"><span style={{ width: `${((this.state.currentStep + 1) / 3) * 100}%` }} /></div>
                            {["Scolarité et famille", "Identité", "Localisation"].map((label, index) => <button type="button" key={label} className={`${index === this.state.currentStep ? "is-active" : ""} ${index < this.state.currentStep ? "is-complete" : ""}`} onClick={() => this.goToStep(index)}><span>{index < this.state.currentStep ? <FeatherIcon icon="check" size="14" /> : index + 1}</span><small>{label}</small></button>)}
                        </div>
                        {this.state.currentStep === 0 && <>
                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="book-open" size="16" /></span>
                            <div><strong>Parcours scolaire</strong><small>Section, classe et rattachement de l’élève</small></div>
                        </div>
                    {
                        !this.props.classe && !this.props.isArchived && ( <>

                            <div className="form-group col-md-3 mt-3">
                                <label>Année scolaire<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps} disabled={true} className="form-control form-control-sm p-0" value={this.state.years.filter(option => option.value === this.state.yearId)} onChange={(select) => this.setState({ yearId: select.value })} options={this.state.years} />
                            </div>

                            <div className="form-group col-md-6 mt-2">
                                <label className="font-monospace fw-normal">Section<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    defaultValue={this.state.sectionId}
                                    isDisabled={ (this.state.id) ? this.handleCheck("Modifier classe eleve") ? false :  true : false}
                                    value = {
                                            optionsections.filter(option => 
                                            option.value.id == this.state.sectionId)
                                        }
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                sectionId : select.value.id
                                            });
                                        }
                                    }
                                    options={optionsections}
                                />

                            </div>

                            <div className="form-group col-md-3 mt-2">
                                <label className="font-monospace fw-normal">Classe<span className="text-danger">*</span></label>
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    defaultValue={this.state.class}
                                    isDisabled={ (this.state.id) ? this.handleCheck("Modifier classe eleve") ? false :  true : false}
                                    value = {
                                            optionsectionclasses.filter(option => 
                                            option.value == this.state.class)
                                    }
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                class : select.value
                                            });
                                        }
                                    }
                                    options={optionsectionclasses}
                                />
                            </div>

                        </>)
                    }

                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="users" size="16" /></span>
                            <div><strong>Responsables familiaux</strong><small>Responsable principal et liens parentaux</small></div>
                        </div>

                        <div className="form-group col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Responsable<span className="text-danger">*</span></label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionresponsibles.filter(option => 
                                        option.value == this.state.responsible)
                                    }
                                    defaultValue={this.state.responsible}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                responsible : select.value,
                                                fatherId : select.value,
                                                family_name : this.state.family_name ? this.state.family_name : select.family_name,
                                                error: "",
                                                errors: { ...this.state.errors, responsible: "" },
                                            });
                                        }
                                    }
                                    options={optionresponsibles}
                                />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2" onClick={() => this.showModal()}><FeatherIcon icon="user-plus"></FeatherIcon></button>
                            </div>
                        </div>

                        <div className="form-group col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Père</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionresponsibles.filter(option => 
                                        option.value == this.state.fatherId)
                                    }
                                    defaultValue={this.state.fatherId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                fatherId : select.value,
                                            });
                                        }
                                    }
                                    options={optionresponsibles}
                                />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2" onClick={() => this.showModal()}><FeatherIcon icon="user-plus"></FeatherIcon></button>
                            </div>
                        </div>

                        <div className="form-group col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Mère</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionresponsibles.filter(option => 
                                        option.value == this.state.motherId)
                                    }
                                    defaultValue={this.state.motherId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                motherId : select.value,
                                            });
                                        }
                                    }
                                    options={optionresponsibles}
                                />
                                <button className="btn btn-outline-primary" type="button" id="button-addon2" onClick={() => this.showModal()}><FeatherIcon icon="user-plus"></FeatherIcon></button>
                            </div>
                        </div>

                        {/* <div className="form-group col-md-4 mt-2 d-none">
                            <label className="font-monospace fw-normal">Catégorie</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optioncategorystudents.filter(option => 
                                        option.value == this.state.category_student)
                                    }
                                    defaultValue={this.state.category_student}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                category_student : select.value,
                                                name_category : select.label,
                                            });
                                        }
                                    }
                                    options={optioncategorystudents}
                                />
                            </div>
                        </div> */}

                        </>}
                        {this.state.currentStep === 1 && <>
                        <div className="col-12 student-form__section-title">
                            <div className="">
                                <div><strong><span><FeatherIcon icon="settings" size="16" /></span> Situation scolaire</strong><small>Choisissez le statut actuel de l’élève</small></div>
                            </div>
                            <div className="ms-5">
                                <label className="font-monospace fw-normal">Statut élève<span className="text-danger">*</span></label>
                                <div className="input-group pt-2" role="radiogroup" aria-label="Statut élève" aria-required="true">
                                    <label htmlFor="student-status-active">
                                        <input id="student-status-active" type="radio" name="status" value="1"
                                            checked={Number(this.state.status) === 1}
                                            onChange={() => this.setState({ status : 1 })} />
                                        Actif
                                    </label>
                                    <label htmlFor="student-status-inactive">
                                        <input id="student-status-inactive" type="radio" name="status" value="2"
                                            checked={Number(this.state.status) === 2}
                                            onChange={() => this.setState({ status : 2 })} />
                                        Non actif
                                    </label>
                                    <label htmlFor="student-status-abandoned">
                                        <input id="student-status-abandoned" type="radio" name="status" value="0"
                                            checked={Number(this.state.status) === 0}
                                            onChange={() => this.setState({ status : 0 })} />
                                        Abandon
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="credit-card" size="16" /></span>
                            <div><strong>Identité de l’élève</strong><small>Informations personnelles et références administratives</small></div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="nom-id-icon">Nom<span className="text-danger">*</span></label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="last_name" minLength={2} maxLength={50} value={this.state.last_name} id="nom-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="postnom-id-icon">Post-nom<span className="text-danger">*</span></label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="family_name" maxLength={50} value={this.state.family_name} id="postnom-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="prenom-id-icon">Prénom</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm"  onChange={this.handleInput} name="first_name" maxLength={50} value={this.state.first_name} id="prenom-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="user-plus"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="matricule-id-icon">Matricule / N°<span className="text-danger"></span></label>
                                <div className="position-relative mt-1">
                                    <input type="text" maxLength={20} className="form-control form-control-sm" onChange={this.handleInput} name="matricule"  value={this.state.matricule} id="matricule-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="trello"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-md-4 mt-2 d-none">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="numero-id-icon">N° d'identité</label>
                                <div className="position-relative mt-1">
                                    <input type="number" className="form-control form-control-sm"  onChange={this.handleInput} name="identity_number"  value={this.state.identity_number} id="numero-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="trello"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        
                        {/* <div className="col-md-4 mt-2 d-none">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="email-id-icon">Email</label>
                                <div className="position-relative mt-1">
                                    <input type="email" className="form-control form-control-sm"  onChange={this.handleInput} name="email"  value={this.state.email} id="email-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="mail"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className="col-md-4 mt-2  d-none">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="numero-id-icon">N° de téléphone</label>
                                <div className="position-relative mt-1">
                                    <input type="tel" maxLength={9} className="form-control form-control-sm" placeholder="" onChange={this.handleInput} name="tel"  value={this.state.tel} id="numero-id-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="phone-call"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        
                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">Lieu de naissance</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="adress" maxLength={100} value={this.state.adress} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="flag"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">Date de naissance</label>
                                <div className="position-relative mt-1">
                                    <input type="date" className="form-control form-control-sm" onChange={this.handleInput} name="datebirth" value={this.state.datebirth} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="calendar"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">N° ID</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="numberId" maxLength={20} value={this.state.numberId} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="file"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">N° permanant</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="number_perm" maxLength={50} value={this.state.number_perm} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="box"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">Code</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="code" maxLength={20} value={this.state.code} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="file"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        </>}
                        {this.state.currentStep === 2 && <>
                        <div className="col-12 student-form__section-title">
                            <span><FeatherIcon icon="map-pin" size="16" /></span>
                            <div><strong>Localisation</strong><small>Adresse administrative et numéro d’habitation</small></div>
                        </div>

                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Region / Territoire</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    required={true}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionterritories.filter(option => 
                                        option.value == this.state.territoryId)
                                    }
                                    defaultValue={this.state.territoryId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                territoryId : select.value,
                                                isTerritory : select.value ? false : true,
                                            });
                                        }
                                    }
                                    options={ optionterritories }
                                />
                            </div>
                        </div>

                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Commune</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    required={true}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionscommunes.filter(option => 
                                        option.value == this.state.communeId)
                                    }
                                    defaultValue={this.state.communeId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                communeId : select.value,
                                                isCommune : select.value ? false : true,
                                            });
                                        }
                                    }
                                    options={ optionscommunes }
                                />
                            </div>
                        </div>

                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Groupement</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    required={true}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optiongroupments.filter(option => 
                                        option.value == this.state.groupmentId)
                                    }
                                    defaultValue={this.state.groupmentId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                groupmentId : select.value,
                                                isGroupment : select.value ? false : true,
                                            });
                                        }
                                    }
                                    options={ optiongroupments }
                                />
                            </div>
                        </div>

                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Quartiers</label>
                            <div className="input-group">
                                <Select {...selectMenuProps}
                                    required={true}
                                    className="form-control  form-control-sm p-0"
                                    value = {
                                        optionquarties.filter(option => 
                                        option.value == this.state.quartierId)
                                    }
                                    defaultValue={this.state.quartierId}
                                    onChange={
                                        (select) => {
                                            this.setState({
                                                quartierId : select.value,
                                                isQuartier : select.value ? false : true,
                                            });
                                        }
                                    }
                                    options={ optionquarties }
                                />
                            </div>
                        </div>

                        <div className="col-md-4 mt-2">
                            <div className="form-group has-icon-left">
                                <label className="font-monospace fw-normal" htmlFor="first-name-icon">Numéro</label>
                                <div className="position-relative mt-1">
                                    <input type="text" className="form-control form-control-sm" onChange={this.handleInput} name="number_house" value={this.state.number_house} id="first-name-icon" />
                                    <div className="form-control-icon text-secondary">
                                        <FeatherIcon icon="file"></FeatherIcon>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className=" col-md-4 mt-2">
                            <label className="font-monospace fw-normal">Genre <span className="text-danger">*</span></label>
                            <div className="ev-choice-group">
                                <label className="ev-choice" htmlFor="student-masculin"><input id="student-masculin" type="radio" name="genre" value="Masculin" checked={this.state.genre === "Masculin"} onChange={this.handleInput} /><span>Masculin</span></label>
                                <label className="ev-choice" htmlFor="student-feminin"><input id="student-feminin" type="radio" name="genre" value="Feminin" checked={this.state.genre === "Feminin"} onChange={this.handleInput} /><span>Féminin</span></label>
                            </div>
                        </div>


                        {
                            this.state.category_student && (
                                <div className=" col-md-12 mt-2">
                                    <label className="font-monospace fw-normal">Catégorie de paiement { this.state.name_category } </label>
                                    <div className="input-group p-0">
                                        <Select {...selectMenuProps}
                                            className="form-control form-control-sm p-0"
                                            closeMenuOnSelect={false}
                                            defaultValue={[ ]}
                                            isMulti
                                            options={optionsectschoolcatstudcats}
                                            onChange={
                                                (select) => {
                                                    this.setState({
                                                        sectschoolcatstudcat : select
                                                    });
                                                }
                                            }
                                        />
                                    </div>
                                </div>
                            )
                        }

                        <div className={ this.state.id ? "col-12 student-form__profile mt-3" : "d-none"}>
                            <div className="input-group pt-2">
                                <input type={"checkbox"} name="avatar" onChange={this.handleInputAvatar} className="rounded m-2" id="avatar" /> <label htmlFor="avatar">Modifier la photo de profil</label>
                            </div>
                            <div className={ this.state.avatar ? "" : "d-none"} >
                                <ProfilImage userId={this.state.userId} />
                            </div>
                        </div>
                        </>}
                        </>}
                        
                    </Modal.Body>
                    <Modal.Footer>
                        {/* {
                            !this.props.isArchived && this.state.id && this.handleCheck("Afficher archive") == true &&(
                                <button onClick={() => this.storeStudent(1)} className="btn btn-outline-success btn-sm"><FeatherIcon icon="archive"></FeatherIcon> Archiver</button>
                            )
                        } */}
                        <span className="student-form__footer-note"><FeatherIcon icon="info" size="14" /> Les champs marqués d’un * sont obligatoires</span>
                        <button type="button" onClick={this.props.showModal} className="btn btn-light student-form__button"><FeatherIcon icon="x" size="16" /> Fermer</button>
                        {this.state.entryMode !== "excel" && this.state.currentStep > 0 && <button type="button" onClick={() => this.goToStep(this.state.currentStep - 1)} className="btn btn-light student-form__button"><FeatherIcon icon="arrow-left" size="16" /> Précédent</button>}
                        {this.state.entryMode !== "excel" && this.state.currentStep < 2 && <button type="button" onClick={() => this.goToStep(this.state.currentStep + 1)} className="btn btn-primary student-form__button">Suivant <FeatherIcon icon="arrow-right" size="16" /></button>}
                        {this.state.entryMode !== "excel" && this.state.currentStep === 2 && <>
                        <button type="button" onClick={() => this.storeStudent()} disabled={this.state.btn} className="btn btn-primary student-form__button"><FeatherIcon icon="check" size="16" /> {this.state.btn ? "Enregistrement..." : (this.props.isArchived ? "Désarchiver" : "Sauvegarder")}</button>
                        </>}
                    </Modal.Footer>
            </Modal>
            

            <ParentfamilyForm 
                isModal={this.state.isModal} 
                formData={{}} 
                showModal={this.showModal}
            />

            <TerritoryForm
                isModal={this.state.isTerritory}
                showModal={this.showModalTerritory}
            />

            <CommuneForm
                isModal={this.state.isCommune}
                showModal={this.showModalCommune}
            />

            <GroupmentForm
                isModal={this.state.isGroupment}
                showModal={this.showModalGroupment}
            />

            <QuartierForm
                isModal={this.state.isQuartier}
                showModal={this.showModalQuartier}
            />

        </div>
        )
    }
}
export default StudentForm;
